import { io } from "socket.io-client";


const token = localStorage.getItem("token");

// const socket = io("http://localhost:5003", {
//   transports: ["websocket"],
//   auth: {
//     token: token,
//   },
// });


const socket = io("https://socket.accunityhr.in", {
  transports: ["websocket"],
  auth: {
    token: token,
  },
});


// const socket = io("http://192.168.0.5:5003", {
//   transports: ["websocket"],
//   auth: {
//     token: token,
//   },
// });


// const socket = io("testrecord.socket.accunityhr.in", {
//   transports: ["websocket"],
//   auth: {
//     token: token,
//   },
// });


export default socket;


// import { io } from "socket.io-client";

// let socket;

// export const connectSocket = () => {
//   const token = localStorage.getItem("token");
    // Base URLs for each microservice of local
//   socket = io("http://localhost:5003", {
//     transports: ["websocket"],
//     auth: { token },
//     autoConnect: true, // Set to false if you want to manually connect
//     reconnection: true,
//   });

//   socket.on("connect_error", (err) => {
//     console.error("Socket connection error:", err.message);
//   });

//   return socket;
// };

// export const getSocket = () => {
//   if (!socket) {
//     return connectSocket(); // ensure it's created if not
//   }
//   return socket;
// };



